import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import tr from './locales/tr.json';
import en from './locales/en.json';

const resources = {
    en: {
        translation: en
    },
    tr: {
        translation: tr
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'appLanguage'
        },
        saveMissing: true, // Enable saving missing keys
        missingKeyHandler: (lng, ns, key, fallbackValue) => {
            console.warn(`[i18n] Missing key: "${key}" in language: "${lng}"`);
        }
    });

export default i18n;
